import axios from 'axios'

class DeliveryAreasService {
  getDeliveryAreas = (page, size, search) =>
    axios({
      url: 'delivery-area',
      method: 'GET',
      params: {
        page,
        take: size,
        ...(search ? { search } : {}),
      },
    })

  pullDeliveryAreas = () =>
    axios({
      url: 'delivery-area/pull',
      method: 'GET',
    })

  updateAreaGovernorate = (id, governorateId) =>
    axios({
      url: `delivery-area/${id}/governorate`,
      method: 'PUT',
      data: { governorateId },
    })
}

export default new DeliveryAreasService()

